import { BACKEND_URL } from "../../views/common/utils/constants";
// import { getQueryStrings } from "../../views/common/utils/helpers";
import { IAPIResponse } from "../../views/common/utils/interfaces";
import { errorToastify } from "../../views/common/utils/Toasty";
import { CustomAxios } from "../customAxios";

export const getBuyers = async () => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/admin/buyers`
    );

    if (!result.status) {
      throw new Error(result.message);
    }
    return result;
  } catch (error) {
    if (typeof error === "string") {
      // errorToastify(error);
    }
  }
};

export const getBuyerDetails = async (inputData: any) => {
  const { slug } = inputData || {};

  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/admin/buyers/${slug}`
      // url
    );

    // const result = tempDummyDetail;

    if (!result.status) {
      throw new Error(result.message);
    }
    return result;
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};
